/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: {},
    variants: {
        link: (props) => ({
            color: 'yellow.400',
            ...props.theme.textStyles.bookSmall
        }),
        'menu-link': (props) => ({
            color: 'black',
            justifyContent: 'flex-start',
            ...props.theme.textStyles.mediumSmall,
            padding: '0 1rem',
            _hover: {bg: 'gray.50', textDecoration: 'none'},
            _activeLink: {
                bg: 'gray.50',
                textDecoration: 'none'
            }
        }),
        'menu-link-mobile': {
            color: 'black',
            justifyContent: 'flex-start',
            fontSize: 'sm',
            _hover: {bg: 'gray.50', textDecoration: 'none'},
            _activeLink: {
                bg: 'gray.100',
                textDecoration: 'none'
            }
        },
        primary: {
            borderRadius: '3.23894rem',
            border: '1px solid',
            borderColor: 'gray.900',
            backgroundColor: 'gray.900',
            color: 'white',
            _hover: {backgroundColor: 'gray.800', textDecoration: 'none'},
            _disabled: {backgroundColor: 'gray.100', color: 'gray.300', borderColor: 'gray.100'},
            _activeLink: {
                bg: 'gray.800',
                textDecoration: 'none'
            }
        },
        solid: {
            primary: {
                borderRadius: '3.23894rem',
                border: '1px solid',
                borderColor: 'gray.900',
                backgroundColor: 'gray.900',
                color: 'white',
                _hover: {backgroundColor: 'gray.800', textDecoration: 'none'},
                _disabled: {
                    backgroundColor: 'gray.100',
                    color: 'gray.300',
                    borderColor: 'gray.100'
                },
                _activeLink: {
                    bg: 'gray.800',
                    textDecoration: 'none'
                }
            }
        },
        footer: {
            borderRadius: '3.23894rem',
            width: 'auto',
            padding: '1.8rem 2.8rem',
            border: '1.3px solid',
            borderColor: 'yellow.400',
            backgroundColor: 'gray.900',
            fontWeight: 'light',
            fontSize: 'lg',
            lineHeight: 7,
            _hover: {bg: 'gray.800', textDecoration: 'none'},
            _activeLink: {
                bg: 'gray.800',
                textDecoration: 'none'
            }
        },
        outline: {
            borderRadius: '3.23894rem',
            border: '1px solid',
            borderColor: 'gray.900',
            color: 'gray.900',
            _active: {
                bg: 'white',
                textDecoration: 'none'
            },
            _hover: {borderColor: 'gray.800', color: 'gray.800', backgroundColor: 'white'},
            _disabled: {borderColor: 'gray.300', color: 'gray.300'}
        },
        contiOutline: {
            borderRadius: '3.23894rem',
            border: '2px solid',
            borderColor: 'yellow.400',
            backgroundColor: 'gray.900',
            color: 'white',
            _hover: {bg: 'gray.800', textDecoration: 'none'},
            _disabled: {bg: 'gray.100', color: 'gray.300', borderColor: 'gray.100'},
            _activeLink: {
                bg: 'gray.800',
                textDecoration: 'none'
            }
        }
    },
    sizes: {
        lg: (props) => ({
            ...props.theme.textStyles.book2Xlarge,
            padding: '2.5rem 4.25rem !important' // 40px 68px
        }),
        md: (props) => ({
            ...props.theme.textStyles.bookLarge,
            padding: '1.8125rem 2.5rem' //29px 40px
        })
    },
    defaultProps: {
        variant: 'primary'
    }
}
